import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import moment from "moment";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import Logs from "../../Logs/Logs";
import { HandlePurchaseRequestStatus } from "../../../utility/CommonFunctions";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";

export default function TransferAssetDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [pageStates, setPageStates] = useState({
    transferAssetDetail: [],
  });
  const [modal, setModal] = useState({
    approveRejectModal: false,
  });

  useEffect(() => {
    GetTransferAssetDetail();
  }, []);

  const GetTransferAssetDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_transfer_asset_detail + `?transferAssetId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          transferAssetDetail: response?.data,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const toggle = (type) => {
    setModal((prevModal) => ({
      ...prevModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
    }));
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(apiUrl.update_transfer_asset + `?transferAssetId =${id}`, option).then(
      (res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetTransferAssetDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      }
    );
  };

  return (
    <>
      <>
        {isLoading && <BgBlurLoader />}
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-start justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button className="btn back-arrow" onClick={() => navigate(-1)}>
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">Transfer Asset Detail</h1>
            </div>
          </div>
          <div className="card manage-user-list">
            <div className="card-body">
              <ul
                className={
                  isLoading
                    ? "row list-unstyled mt-4 loading-skeleton"
                    : "row list-unstyled mt-4"
                }
              >
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Transfer Asset Number :-
                    </span>
                    {pageStates?.transferAssetDetail?.taNumber || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">From Site :-</span>
                    {pageStates?.transferAssetDetail?.fromSite?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">To Site :-</span>
                    {pageStates?.transferAssetDetail?.toSite?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Date :-</span>
                    {moment(pageStates?.transferAssetDetail?.date).format(
                      "DD-MM-YYYY"
                    ) || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Financial Year :-</span>
                    {pageStates?.transferAssetDetail?.financialYear || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Created By :-
                    </span>
                    {pageStates?.transferAssetDetail?.user?.name || "--"}
                  </p>
                </li>
                <li className="col-12 ">
                  <p>
                    <span className="text-muted fs-5 d-block">Description :-</span>
                    {pageStates?.transferAssetDetail?.description || "--"}
                  </p>
                </li>
              </ul>
              <div className="col-12 ">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                  <h4 className="fs-3 rajdhani-semibold my-4 ">Items</h4>
                </div>
                <table className="table mt-3">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Expense Head</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageStates?.transferAssetDetail?.transferassetitems?.length > 0 ? (
                      pageStates?.transferAssetDetail?.transferassetitems?.map?.(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item?.item?.name}</td>
                            <td>{item?.expensehead?.name}</td>
                            <td>{item?.quantity}</td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td className="text-center border-0" colSpan="12">
                          <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                            <NoRecordIcon />
                            {"No record found"}
                          </div>
                        </td>
                      </tr>
                    )}

                    <tr className="d-none">
                      <td colspan="11" className="text-center fw-bold">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}
